export const blockIconsActivitiesSportsEsportsNew = (
	<span className='material-symbols-outlined'>sports_esports</span>
);
